<template>
    <v-container
      class="py-0"
      fluid>
        <v-row
            align="center"
            justify="center"
            class="dashboard-links"
        >
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                
            >
                <v-card
                    color="primary"
                    dark
                    to="/cleaners"
                    flat
                    tile
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-account-supervisor-circle
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">Cleaners</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    color="primary"
                    dark
                    to="/jobs"
                    flat
                    tile
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-map-marker-down
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">Jobs</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    color="primary"
                    dark
                    to="/customers"
                    flat
                    tile
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-account-group
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">Customers</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    color="primary"
                    dark
                    flat
                    tile
                    to="/chemicals"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-beaker-check
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">Chemicals</span>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-card
            flat
            :loading="loading"
            loader-height="10"
            tile
            min-width="100%"
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
            </v-toolbar>
            <v-row
                align="center"
                justify="center"
                class="pa-0"
            >
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="pa-0 ma-0"
                >
                <mapbox
                    v-if="mapKey != 0"
                    access-token="pk.eyJ1IjoiYmlnY2l0eSIsImEiOiJjazhpb2c0cGgwNnh0M21ud2s3YzY4MGpjIn0.0AYL_R9U7wU8WQck6doT-w"
                    :map-options="{
                        style: 'mapbox://styles/mapbox/streets-v9',
                        center: [-86.327204, 32.3524829],
                        zoom: 10,
                    }"
                    @map-load="loaded"
                    @map-click:points="clicked"
                    @map-mouseenter:points="mouseEntered"
                    @map-mouseleave:points="mouseLeft"
                    :key="mapKey"
                />
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex'
    import Mapbox from 'mapbox-gl-vue'
    import PopupContent from '../components/PopupContent.vue'
    import axios from 'axios'

    export default {
        data: () => ({
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,
            pageTitleFull: 'Upcoming Jobs',
            markers: [],
            mapKey: 0
        }),
        async mounted() {
            await this.getData()
            await this.getMarkers()
        },
        components: { Mapbox },
        computed: {
        },
        methods: {
            ...mapActions({
                getData: 'data/getData'
            }),
            getMarkers() {
                this.loading = true
                axios.get('admin/upcoming')
                .then(response => {
                    this.loading = false
                    this.markers = response.data.markers
                    this.mapKey += 1
                    this.$nextTick()
                })
            },
            loaded(map) {
                    map.addLayer({
                        id: 'points',
                        type: 'symbol',
                        source: {
                            type: 'geojson',
                            data: {
                                type: 'FeatureCollection',
                                features: this.markers,
                            },
                        },
                        layout: {
                            'text-field': ['get', 'title'],
                            'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                            'text-radial-offset': 0.5,
                            'text-justify': 'auto',
                            'icon-image': 'circle-15'
                        },
                    })
            },
            clicked(map, e) {
                if (e.features) {
                    const coordinates = e.features[0].geometry.coordinates.slice()

                    // Ensure that if the map is zoomed out such that multiple
                    // copies of the feature are visible, the popup appears
                    // over the copy being pointed to.
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
                    }

                    new mapboxgl.Popup()
                    .setLngLat({ lng: coordinates[0], lat: coordinates[1] })
                    .setHTML('<div id="vue-popup-content"></div>')
                    .addTo(map)

                    new PopupContent({
                    propsData: { feature: e.features[0] },
                    }).$mount('#vue-popup-content')
                }
            },
            mouseEntered(map) {
                map.getCanvas().style.cursor = 'pointer'
            },
            mouseLeft(map) {
                map.getCanvas().style.cursor = ''
            },
        }
    }
</script>

<style lang="sass">
.dashboard-links
    padding: 4px
    
    .col-6
        padding: 4px

        .v-card 
            min-height: calc((100vh - 382px)/3)
            display: flex
            flex-wrap: wrap
            align-content: center
</style>